const React = require('react');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const trim = require('mn-utils/trim');
const noop = require('mn-utils/noop');
const filter = require('mn-utils/filter');
const delay = require('mn-utils/delay');
const isEmail = require('mn-utils/isEmail');
const isString = require('mn-utils/isString');
const formatTime = require('mn-utils/formatTime');
const {
  PHONE_COUNTRY_CODES,
  COUNTRIES_UPPERCASE,
} = require('../../../../constants/countries');
const {
  backLocation,
} = require('../../../../router');
const withState = require('../../../../utils/withState');
const {
  apiAdminPayoutNiumBeneficiaryAdd,
  apiAdminPayoutNiumBeneficiaryGet,
} = require('../../../../api/admin/payout/nium/beneficiary');
const {
  openV1PopupInfo,
} = require('../../../../emitters/popup');
const LayoutB = require('../../../dumb/Layout/B');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const TextField = require('../../../dumb/TextField/Reg2');
const ButtonJ = require('../../../dumb/Button/J');
const Select = require('../../../dumb/Select/E');
const ButtonBack = require('../../../dumb/Button/Back');
const KeyboardDatePicker = require('../../../dumb/KeyboardDatePicker/C');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');


const DEFAULT_RELATIONSHIP = 'Lunu Retailer';

const ACCOUNT_TYPES = [
  'Company',
  'Individual',
];
const BANK_ACCOUNT_TYPES = [
  'Checking', 'Saving', 'Maestra',
];
const IDENTIFICATION_TYPES = [
  'Company Organization Code', 'Company Social Credit Code',
  'Passport', 'Company Registration No.', 'CUIT', 'CUIL', 'CPF',
  'CNPJ', 'RUT', 'CC', 'NIT', 'CE', 'PASS', 'DNI', 'RUC', 'CI',
];
const ACCOUNT_IDENTIFIER_TYPES = [
  'MOBILE', 'UEN', 'NRIC',
];

function cardDateHandle(v) {
  return v.replace(/[^0-9]/gim, '').substr(0, 2);
}


module.exports = withState((setState, self, onMount) => {
  const changeProvider = changeProviderProvider(setState);
  let _cancel = noop;
  let _id;

  const handleChangeAccountType = handleProvider('accountType');
  const handleChangeName = changeProvider('name');
  const handleChangeNameLocalLanguage = changeProvider('nameLocalLanguage');
  const handleChangeBirthday = handleProvider('birthday');
  const handleChangeEmail = changeProvider('email');
  const handleChangeContactCountryCode = handleProvider('contactCountryCode');
  const handleChangePhone = changeProvider('phone');
  const handleChangeCountryCode = handleProvider('countryCode');
  const handleChangeRegion = changeProvider('region');
  const handleChangeCity = changeProvider('city');
  const handleChangePostcode = changeProvider('postcode');
  const handleChangeAddress = changeProvider('address');
  const handleChangeBankAccountType = handleProvider('bankAccountType');
  const handleChangeBankName = changeProvider('bankName');
  const handleChangeAccountNumber = changeProvider('accountNumber');
  const handleChangeBankCode = changeProvider('bankCode');
  const handleChangeIdentificationType = handleProvider('identificationType');
  const handleChangeIdentificationValue = changeProvider('identificationValue');
  const handleChangeAccountIdentifierType = handleProvider('accountIdentifierType');
  const handleChangeAccountIdentifierValue = changeProvider('accountIdentifierValue');
  const handleChangeCardNumber = changeProvider('cardNumber');
  const handleChangeEncryptedCardNumber = changeProvider('encryptedCardNumber');
  const handleChangeCardMonth = changeProvider('cardMonth', 0, cardDateHandle);
  const handleChangeCardYear = changeProvider('cardYear', 0, cardDateHandle);
  const handleChangeRelationship = changeProvider('relationship');


  function handleProvider(key) {
    return (v) => {
      setState({
        [key]: v,
      });
    };
  }
  function update() {
    _cancel();
    _cancel = delay(() => {
      setState({
        loading: true,
      });
      _cancel = apiAdminPayoutNiumBeneficiaryGet({
        merchant_id: _id,
      }).finally((error, response) => {
        response = response || {};

        const cardExpiry = response.card_expiry;
        const cardExpiryDate = cardExpiry ? new Date(cardExpiry) : 0;


        setState({
          error,
          response,
          loading: false,
          accountType: response.account_type,
          accountNumber: response.account_number,

          name: response.name,
          nameLocalLanguage: response.name_local_language,
          birthday: response.dob,

          email: response.email,

          contactCountryCode: response.contact_country_code,
          phone: response.contact_number,

          countryCode: response.country_code,
          region: response.state,
          city: response.city,
          postcode: response.postcode,
          address: response.address,

          bankAccountType: response.bank_account_type,
          bankName: response.bank_name,
          bankCode: response.bank_code,
          identificationType: response.identification_type,
          identificationValue: response.identification_value,

          cardNumber: response.card_number,
          encryptedCardNumber: response.encrypted_card_number,

          cardMonth: cardExpiryDate ? formatTime(cardExpiryDate, '{mm}') : '',
          cardYear: cardExpiryDate ? formatTime(cardExpiryDate, '{yy}') : '',

          relationship: response.relationship,

          accountIdentifierType: response.account_identifier_type,
          accountIdentifierValue: response.account_identifier_value,
        });
      }).cancel;
    });
  }

  onMount(() => {
    return () => {
      _cancel();
    };
  });

  return (state, props) => {
    const MAX_LENGTH = 250;

    const params = props.params || {};
    const {
      id,
    } = params;

    _id === id || update(_id = id);


    const clicked = state.clicked || false;

    const accountType = state.accountType;
    const invalidAccountType = !accountType;

    const name = state.name || '';
    const _name = trim(name);
    const invalidName = !_name;

    const nameLocalLanguage = state.nameLocalLanguage || '';


    const birthday = state.birthday || null;

    const email = state.email || '';
    const _email = trim(email);
    const invalidEmail = !isEmail(_email);


    const contactCountryCode = state.contactCountryCode;
    const invalidContactCountryCode = !contactCountryCode;

    const phone = state.phone || '';
    const _phone = trim(phone);
    const invalidPhone = !_phone;

    const countryCode = state.countryCode;
    const invalidCountryCode = !countryCode;

    const region = state.region || '';
    const _region = trim(region);
    const invalidRegion = !_region;

    const city = state.city || '';
    const _city = trim(city);
    const invalidCity = !_city;

    const address = state.address || '';
    const _address = trim(address);
    const invalidAddress = !_address;

    const postcode = state.postcode || '';
    const _postcode = trim(postcode);
    const invalidPostcode = !_postcode;


    const bankAccountType = state.bankAccountType;
    const invalidBankAccountType = !bankAccountType;

    const accountNumber = state.accountNumber || '';
    const _accountNumber = trim(accountNumber);
    const invalidAccountNumber = !_accountNumber;

    const bankName = state.bankName || '';
    const _bankName = trim(bankName);
    const invalidBankName = !_bankName;

    const bankCode = state.bankCode || '';
    const _bankCode = trim(bankCode);
    const invalidBankCode = !_bankCode;

    const identificationType = state.identificationType || '';

    const identificationValue = state.identificationValue || '';
    const _identificationValue = trim(identificationValue);

    const cardNumber = state.cardNumber || '';

    const encryptedCardNumber = state.encryptedCardNumber || '';

    const cardMonth = state.cardMonth || '';
    const cardMonthNum = parseInt(cardMonth);

    const cardYear = state.cardYear || '';
    const cardYearNum = parseInt(cardYear);

    const hasCardExpiry = !!(cardMonth || cardYear);

    const invalidCardMonth = hasCardExpiry
      && (cardMonth.length < 2 || cardMonthNum > 12 || cardMonthNum < 1);
    const invalidCardYear = hasCardExpiry
      && (cardYear.length < 2 || cardYearNum < 1);
    const invalidCardExpiry = invalidCardMonth || invalidCardYear;

    const cardExpiry = hasCardExpiry && !invalidCardExpiry
      ? `20${cardYear}-${cardMonth}`
      : '';

    let relationship = state.relationship;
    relationship === undefined && (relationship = DEFAULT_RELATIONSHIP);
    const _relationship = trim(relationship);
    const invalidRelationship = !_relationship;


    const accountIdentifierType = state.accountIdentifierType || '';
    const _accountIdentifierType = trim(accountIdentifierType);


    const accountIdentifierValue = state.accountIdentifierValue || '';
    const _accountIdentifierValue = trim(accountIdentifierValue);


    const disabled = invalidAccountType
      || invalidName
      || invalidEmail
      || invalidPhone
      || invalidCountryCode
      || invalidRegion
      || invalidCity
      || invalidAddress
      || invalidPostcode
      || invalidAccountNumber
      || invalidBankName
      || invalidRelationship
      || invalidCardExpiry;


    return (
      <LayoutB>
        <HeaderA>
          <CaptionA
            className="fx1 wmin0"
            description={id}
          >Payout</CaptionA>
          <ButtonBack
            onClick={backLocation}
          />
        </HeaderA>
        <WrapperWithLoading
          className="mt30"
          loading={state.loading}
        >
          <div>
            <Select
              className="w"
              placeholder="Account type *"
              error={clicked && invalidAccountType}
              displayEmpty
              items={ACCOUNT_TYPES}
              value={accountType}
              onChange={handleChangeAccountType}
            />
          </div>
          <div className="mt20 cfx mh-10 (lt|w1/3|ph10)>1">
            <TextField
              label="Name *"
              value={name}
              error={clicked && invalidName}
              onChange={handleChangeName}
              maxLength={MAX_LENGTH}
            />
            <TextField
              label="Name in local language"
              value={nameLocalLanguage}
              onChange={handleChangeNameLocalLanguage}
              maxLength={MAX_LENGTH}
            />
            <div>
              <KeyboardDatePicker
                label="Date of birth"
                value={birthday}
                onChange={handleChangeBirthday}
              />
            </div>
          </div>
          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <TextField
              label="Email *"
              value={email}
              error={clicked && invalidEmail}
              onChange={handleChangeEmail}
              maxLength={MAX_LENGTH}
            />
            <div>
              <div className="layoutRow fhaS">
                <div className="w150 pr20">
                  <Select
                    className="w"
                    placeholder="Code *"
                    error={clicked && invalidContactCountryCode}
                    displayEmpty
                    items={PHONE_COUNTRY_CODES}
                    value={contactCountryCode}
                    onChange={handleChangeContactCountryCode}
                  />
                </div>
                <TextField
                  className="fx1"
                  label="Contact number *"
                  value={phone}
                  error={clicked && invalidPhone}
                  onChange={handleChangePhone}
                  maxLength={MAX_LENGTH}
                />
              </div>
            </div>
          </div>
          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <div>
              <Select
                className="w"
                placeholder="Country *"
                error={clicked && invalidCountryCode}
                propName="0"
                propValue="1"
                displayEmpty
                items={COUNTRIES_UPPERCASE}
                value={countryCode}
                onChange={handleChangeCountryCode}
              />
            </div>
            <TextField
              label="State *"
              value={region}
              error={clicked && invalidRegion}
              onChange={handleChangeRegion}
              maxLength={MAX_LENGTH}
            />
          </div>
          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <TextField
              label="City *"
              value={city}
              error={clicked && invalidCity}
              onChange={handleChangeCity}
              maxLength={MAX_LENGTH}
            />
            <TextField
              label="Postcode *"
              value={postcode}
              error={clicked && invalidPostcode}
              onChange={handleChangePostcode}
              maxLength={MAX_LENGTH}
            />
          </div>
          <TextField
            className="mt20"
            label="Address *"
            value={address}
            error={clicked && invalidAddress}
            onChange={handleChangeAddress}
            maxLength={15000}
          />
          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <div>
              <Select
                className="w"
                placeholder="Bank account type *"
                error={clicked && invalidBankAccountType}
                displayEmpty
                items={BANK_ACCOUNT_TYPES}
                value={bankAccountType}
                onChange={handleChangeBankAccountType}
              />
            </div>
            <TextField
              label="Bank name *"
              value={bankName}
              error={clicked && invalidBankName}
              onChange={handleChangeBankName}
              maxLength={MAX_LENGTH}
            />
          </div>
          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <TextField
              label="Bank account number *"
              value={accountNumber}
              error={clicked && invalidAccountNumber}
              onChange={handleChangeAccountNumber}
              maxLength={MAX_LENGTH}
            />
            <TextField
              label="Bank code *"
              value={bankCode}
              error={clicked && invalidBankCode}
              onChange={handleChangeBankCode}
              maxLength={MAX_LENGTH}
            />
          </div>
          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <div>
              <Select
                className="w"
                placeholder="Identification type"
                displayEmpty
                items={IDENTIFICATION_TYPES}
                value={identificationType}
                onChange={handleChangeIdentificationType}
              />
            </div>
            <TextField
              label="Identification value"
              value={identificationValue}
              onChange={handleChangeIdentificationValue}
              maxLength={MAX_LENGTH}
            />
          </div>

          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <div>
              <Select
                className="w"
                placeholder="Account identifier type"
                displayEmpty
                items={ACCOUNT_IDENTIFIER_TYPES}
                value={accountIdentifierType}
                onChange={handleChangeAccountIdentifierType}
              />
            </div>
            <TextField
              label="Account identifier value"
              value={accountIdentifierValue}
              onChange={handleChangeAccountIdentifierValue}
              maxLength={MAX_LENGTH}
            />
          </div>
          <div className="mt20 mh-10 layoutRow fhaS fvaC (ph10|fx1)>1">
            <TextField
              label="Card number"
              value={cardNumber}
              onChange={handleChangeCardNumber}
              maxLength={MAX_LENGTH}
            />
            <TextField
              label="Encrypted card number"
              value={encryptedCardNumber}
              onChange={handleChangeEncryptedCardNumber}
              maxLength={MAX_LENGTH}
            />
            <div className="wmax250">
              <div className="rlv">
                <div className="abs sh13 sb5 f12 ff$2 cF">
                  Card expiry
                </div>
              </div>
              <div className="layoutRow fhaS fvaC">
                <TextField
                  className="fx1"
                  label="MM"
                  value={cardMonth}
                  onChange={handleChangeCardMonth}
                  error={clicked && invalidCardMonth}
                  helperText="invalid value"
                  maxLength={2}
                />
                <div className="ph10">/</div>
                <TextField
                  className="fx1"
                  label="YY"
                  value={cardYear}
                  onChange={handleChangeCardYear}
                  error={clicked && invalidCardYear}
                  helperText="invalid value"
                  maxLength={4}
                />
              </div>
            </div>
          </div>
          <TextField
            className="mt20"
            label="Relationship"
            value={relationship}
            error={clicked && invalidRelationship}
            onChange={handleChangeRelationship}
            maxLength={MAX_LENGTH}
          />
          <div className="pt90 layoutRow fhaB fvaC">
            <ButtonJ
              disabled={clicked && disabled}
              onClick={() => {
                if (disabled) {
                  setState({
                    clicked: true,
                  });
                  return;
                }
                setState({
                  loading: true,
                });
                apiAdminPayoutNiumBeneficiaryAdd(filter({
                  merchant_id: _id,
                  account_type: accountType,
                  account_number: _accountNumber,

                  name: _name,
                  name_local_language: trim(nameLocalLanguage),
                  dob: isString(birthday)
                    ? birthday
                    : (
                      birthday && !isNaN(birthday)
                        ? formatTime(birthday, '{yyyy}-{mm}-{dd}')
                        : ''
                    ),

                  email: _email,

                  contact_country_code: contactCountryCode,
                  contact_number: _phone,

                  country_code: countryCode,
                  state: _region,
                  city: _city,
                  postcode: _postcode,
                  address: _address,

                  bank_account_type: bankAccountType,
                  bank_name: _bankName,
                  bank_code: _bankCode,
                  identification_type: identificationType,
                  identification_value: _identificationValue,

                  card_number: trim(cardNumber),
                  encrypted_card_number: trim(encryptedCardNumber),

                  card_expiry: cardExpiry,

                  relationship: _relationship,

                  account_identifier_type: _accountIdentifierType,
                  account_identifier_value: _accountIdentifierValue,

                })).finally((error) => {
                  setState({
                    loading: false,
                  });
                  error || openV1PopupInfo([
                    'Payout',
                    'Settings have been updated',
                  ]);
                });
              }}
            >Save</ButtonJ>
          </div>
        </WrapperWithLoading>
      </LayoutB>
    );
  };
}, {});
